const educationPage1 = (fieldPercent, majorPercent, bachelorPercent) => {
  let score1 = 0
  let score2 = 0
  let score3 = 0
  let content = null
  let chart = null

  // Chart1 calculation
  if(fieldPercent > 60) score1 = (fieldPercent - 60) / 40
  else if(fieldPercent < 40) score1 = fieldPercent / 40

  // Chart2 calculation
  if(majorPercent > 70) score2 = (majorPercent - 70) / 30

  // Chart3 calculation
  if(bachelorPercent > 80) score3 = (bachelorPercent - 80) / 20
  else if(bachelorPercent < 40)  score3 = bachelorPercent / 40

  if(score1 >= score2 && score1 >= score3) {
    if(fieldPercent > 60) content = 'Looks like there\'s a good chance you\'ll end up working in your field.'
    else if(fieldPercent < 40) content = 'Jobs in this field might be tough to get.'

    chart = 'fieldChart'
  }
  else if(score2 >= score1 && score2 >= score3) {
    content = 'Well this looks like a highly educated group.'
    chart = 'majorChart'
  }
  else if(score3 >= score1 && score3 >= score2) {
    if(bachelorPercent > 50) content = 'To be competitive in this field, you\'ll probably need an advanced degree.'
    else if(bachelorPercent < 20)  content = 'Looks like you might not need an advanced degree to be successful in this field.'

    chart = 'bachelorChart'
  }

  if(!content) chart = null
  return {
    content,
    chart,
  }
}

const careerPage1 = (majorPercent, bachelorPercent, commonMajorName) => {
  let score1 = 0
  let score2 = 0
  let content = null
  let chart = null

  // Chart1 calculation
  if(majorPercent > 50) score1 = (majorPercent - 50) / 50

  // Chart2 calculation
  if(bachelorPercent > 80) score2 = (bachelorPercent - 80) / 20
  else if(bachelorPercent < 40)  score2 = bachelorPercent / 40

  if(score1 >= score2) {
    content = `${commonMajorName} is a very common major in this group.`
    chart = 'majorChart'
  }
  else {
    if(bachelorPercent > 50) content = 'You\'ll probably need an advanced degree to remain competitive in this field.'
    else if(bachelorPercent < 20) content = 'Looks like you might not need an advanced degree to be successful in this field.'

    chart = 'bachelorChart'
  }

  if(!content) chart = null
  return {
    content,
    chart,
  }
}

const salaryInsight = (salary) => {
  const nationalAverageSalary = 50556
  const percent = (salary - nationalAverageSalary) * 100 / nationalAverageSalary
  let adjective = null
  let level = null

  if(percent > 80) {
    adjective = 'significantly'
    level = 'higher'
  }
  else if (percent < 20 && percent > 0) {
    adjective = 'slightly'
    level = 'higher'
  }
  else if (percent < -25) {
    adjective = 'significantly'
    level = 'lower'
  }
  else if (percent > -15 && percent < 0) {
    adjective = 'slightly'
    level = 'lower'
  }

  if(adjective)  return `The average salary for your search is ${adjective} ${level} than the national average salary of $50,556.`

  return null
}

export default {
  educationPage1,
  careerPage1,
  salaryInsight,
}


// WEBPACK FOOTER //
// ./src/utils/resumesearch/getInsight.js